import { render, staticRenderFns } from "./LeadConfirmModal.vue?vue&type=template&id=977c6998&"
import script from "./LeadConfirmModal.vue?vue&type=script&lang=js&"
export * from "./LeadConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports